import { call, put, takeLatest } from "@redux-saga/core/effects";
import UserService from "../../Services/RestApiManager/UserManager/UserService";
import { responseUserAction, errorUserAction, USER_ACTION, responseUsersListAction, errorUsersListAction, responseUserById, errorUserById, responseEditUser, errorEditUser, responseUsersListActionWithOutPagination, errorUsersListActionWithOutPagination, responseImpersonateUser, errorImpersonateUser} from "./UserActionCreator"

export function* userRequest(action) {
    try {
      const response = yield call(UserService.shared.userRequest, action.data);
      yield put(responseUserAction(response));
    } catch (error) {
      yield put(errorUserAction(error));
    }
  }

  export function* usersListRequest(action) {
    try {
      const response = yield call(UserService.shared.usersListRequest, action.data);
      yield put(responseUsersListAction(response));
    } catch (error) {
      yield put(errorUsersListAction(error));
    }
  }
  
  export function* usersListWithOutPagination(action){
    try {
      const response = yield call(UserService.shared.usersListWithOutPaginationRequest, action.data);
      yield put(responseUsersListActionWithOutPagination(response));
    } catch (error) {
      yield put(errorUsersListActionWithOutPagination(error));
    }
  }
  export function* userByIdRequest(action) {
    try {
      const response = yield call(UserService.shared.userByIdRequest, action.data);
      yield put(responseUserById(response));
    } catch (error) {
      yield put(errorUserById(error));
    }
  }


  export function* editUserRequest(action) {
    try {
      const response = yield call(UserService.shared.editUserRequest, action.data);
      yield put(responseEditUser(response));
    } catch (error) {
      yield put(errorEditUser(error));
    }
  }

  export function* impersonateUserRequest(action) {
    try {
      const response = yield call(
        UserService.shared.impersonateUserRequest,
        action.data
      );

      // Prefer local FE env so local testing doesn't open prod employee portal
      const redirectBase =
        process.env.REACT_APP_USER_PORTAL_URL || response?.redirect_url;

      if (redirectBase && response?.access_token && response?.userDetails) {
        const redirectUrl = new URL(redirectBase);
        redirectUrl.searchParams.set("token", response.access_token);
        if (response.refresh_token) {
          redirectUrl.searchParams.set("refreshToken", response.refresh_token);
        }
        redirectUrl.searchParams.set(
          "user",
          JSON.stringify(response.userDetails)
        );
        redirectUrl.searchParams.set("impersonate", "true");
        window.open(redirectUrl.toString(), "_blank");
      }

      yield put(responseImpersonateUser(response));
    } catch (error) {
      yield put(errorImpersonateUser(error));
    }
  }
   
  export function* userWatcherSaga() {
    yield takeLatest(USER_ACTION.REQUEST, userRequest);
    yield takeLatest(USER_ACTION.REQUEST_USERS_LIST, usersListRequest)
    yield takeLatest(USER_ACTION.REQUEST_USER_BY_ID,userByIdRequest)
    yield takeLatest(USER_ACTION.REQUEST_EDIT_USER,editUserRequest)
    yield takeLatest(USER_ACTION.REQUEST_USERS_LIST_WITHOUT_PAGINATION,usersListWithOutPagination)
    yield takeLatest(USER_ACTION.REQUEST_IMPERSONATE_USER, impersonateUserRequest)
  }